import { Component, inject } from '@angular/core';
import {
	LO_DIALOG_DATA,
	LoButton,
	LoDialog,
	LoDialogRef
} from 'lo-design-system';

export interface MetaAdReleaseBlockedData {
	adAccountId: string;
	adAccountName: string;
	activeCampaignsCount: number;
	message: string;
}

export interface MetaAdReleaseBlockedResult {
	navigate?: boolean;
}

@Component({
	standalone: true,
	selector: 'meta-ad-release-blocked-dialog',
	imports: [LoDialog, LoButton],
	template: `
		<lo-dialog heading="Cannot release">
			<p class="lo-type-text-md">{{ data.message }}</p>
			<div loDialogActions>
				<button
					lo-button
					variant="secondary"
					type="button"
					(click)="close()"
				>
					Cancel
				</button>
				<button lo-button type="button" (click)="goToCampaigns()">
					Go to campaigns
				</button>
			</div>
		</lo-dialog>
	`
})
export class MetaAdReleaseBlockedDialogComponent {
	protected readonly data = inject<MetaAdReleaseBlockedData>(LO_DIALOG_DATA);
	private readonly dialogRef =
		inject<
			LoDialogRef<
				MetaAdReleaseBlockedDialogComponent,
				MetaAdReleaseBlockedResult
			>
		>(LoDialogRef);

	close(): void {
		this.dialogRef.close();
	}

	goToCampaigns(): void {
		this.dialogRef.close({ navigate: true });
	}
}
